import { _WINDOW_ } from "./dom";

export const IS_LEGACY_MODE = _WINDOW_.__COOKIE_IS_BROWSER_LEGACY;
